module.exports = __webpack_public_path__ + "static/media/artsozaii.5e1f0b7c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/artsozaii.svg
// module id = 308
// module chunks = 98